import {
    GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_REQUEST,
    GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_SUCCESS,
    GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_FAILED,
} from '../../actions/register-flow/register-payment-plans'

const initialState = {
    domainSubscriptions: null,
    requesting: false,
    error: null,
    completed: false
}

export const registerPaymentPlans = (state = initialState, action) => {
    switch (action.type) {
        case GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                domainSubscriptions: null,
                error: null,
            })
        case GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_SUCCESS:
            return Object.assign({}, state, {
                domainSubscriptions: action.payload.data.payload,
                requesting: false,
                error: action.error,
            })
        case GET_AVAILABLE_DOMAIN_SUBSCRIPTIONS_FAILED:
            return Object.assign({}, state, {
                domainSubscriptions: null,
                requesting: false,
                error: null,
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/register-flow/register-payment-plans.js